export const PROTECTED_LOCAL_TRANSLATION_KEYS = ['Subscription.freeTrial', 'PlansSection.inTrial'];

export const mergeTranslationMessages = ({ localMessages = {}, remoteMessages = {} } = {}) => {
  const merged = {
    ...(localMessages || {}),
    ...(remoteMessages || {}),
  };

  PROTECTED_LOCAL_TRANSLATION_KEYS.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(localMessages, key)) {
      merged[key] = localMessages[key];
    }
  });

  return merged;
};
